import * as React from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function FadeIn({ children }) {
  const outerRef = React.useRef(null);
  const innerRef = React.useRef(null);

  React.useLayoutEffect(() => {
    if (!outerRef.current || !innerRef.current) {
      return undefined;
    }

    const ctx = gsap.context(() => {
      gsap.set(innerRef.current, {
        opacity: 0,
        y: 50,
      });

      gsap.to(innerRef.current, {
        opacity: 1,
        y: 0,
        clearProps: "opacity,transform",
        immediateRender: false,
        scrollTrigger: {
          trigger: outerRef.current,
          start: "top center",
          toggleActions: "play none none none",
          invalidateOnRefresh: true,
        },
      });
    }, outerRef);

    const refreshTriggers = () => ScrollTrigger.refresh();
    if (typeof window !== "undefined") {
      if (document.readyState === "complete") {
        refreshTriggers();
      } else {
        window.addEventListener("load", refreshTriggers, { once: true });
      }
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("load", refreshTriggers);
      }
      ctx.revert();
    };
  }, []);

  return (
    <>
      <div ref={outerRef}>
        <div ref={innerRef}>{children}</div>
      </div>
    </>
  );
}
